module.exports = __webpack_public_path__ + "static/event5-91854c4a14f459f134d8cbb650617576.jpg";